import { assetUrl } from '@ircf/config';
import { cn } from '@ircf/ui';

export function PoweredByTameDynamics({ compact = false }: { compact?: boolean }) {
  return (
    <a
      href="https://tame-dynamics.com/"
      aria-label="Powered by Tame Dynamics"
      className={cn(
        'fixed right-4 bottom-[calc(1rem+env(safe-area-inset-bottom,0px))] z-40 flex flex-col items-center gap-1 rounded-xl border border-white/15 bg-near-black/90 px-3 py-2 shadow-2xl backdrop-blur-md transition-[border-color,transform] duration-200 hover:-translate-y-0.5 hover:border-white/30 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-warm-white motion-reduce:transform-none sm:right-6 sm:bottom-[calc(1.5rem+env(safe-area-inset-bottom,0px))]',
        compact &&
          'right-2 bottom-[calc(.5rem+env(safe-area-inset-bottom,0px))] px-2 py-1.5 sm:right-4 sm:bottom-[calc(1rem+env(safe-area-inset-bottom,0px))]',
      )}
    >
      <span
        className={cn(
          'text-[0.625rem] font-semibold tracking-[0.2em] text-cool-steel uppercase',
          compact && 'text-[0.5rem]',
        )}
      >
        Powered by
      </span>
      <img
        src={assetUrl('/assets/brand/tame-dynamics.png')}
        alt="Tame Dynamics"
        className={cn('h-auto w-32 sm:w-36', compact && 'w-24 sm:w-28')}
      />
    </a>
  );
}
